export * from '../data/brands/ftl/styles/variables';